// extracted by mini-css-extract-plugin
export var eyebrow = "_ka-3";
export var heroImage = "_ka-4";
export var main = "_ka-2";
export var modal = "_ka-0";
export var shell = "_ka-1";